// extracted by mini-css-extract-plugin
export default {"ratingCell":"created_cell_ratingCell__ZcTHv","clearIcon":"created_cell_clearIcon__zgDch"};